import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {UserCarePlanVetineoVisitTypeBundle} from "../user-care-plan-vetineo-visit-type-bundle.model";

export class UserCarePlanVisitTypeItemDgSearchResults extends GenericDgSearchResults {
  public results: UserCarePlanVetineoVisitTypeBundle[];

  constructor(total: number, results: UserCarePlanVetineoVisitTypeBundle[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}



